import React, { useState } from "react";
import { Container, Box, Typography, Button } from "@mui/material";
import heroimg from "../assets/hero.png";
import DraftsIcon from "@mui/icons-material/Drafts";
import logoimg from "../assets/logo.png";
import axios from "axios";
import { API_BASE_URL } from "../components/Config";
import { useSnackbar } from "notistack";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenTwoToneIcon from "@mui/icons-material/LockOpenTwoTone";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
const CheckUser = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [referenceNumber, setReferenceNumber] = useState("");
  const [fullName, setFullName] = useState("");
  const [showpss, setShowpss] = useState(false);
  const navigate = useNavigate();

  const handelAPIFunc = async () => {
    if (!referenceNumber) {
      enqueueSnackbar("Please enter your plan reference number", {
        variant: "error",
      });
      return;
    }
    if (!fullName) {
      enqueueSnackbar("Please enter your full name", { variant: "error" });
      return;
    }
    try {
      const data = {
        reference_number: referenceNumber,
      };
      const res = await axios.post(`${API_BASE_URL}/accounts/login/`, data);
      if (res?.data?.token) {
        enqueueSnackbar("User logged in successfully", { variant: "success" });
        Cookies.set("token", res?.data?.token, { expires: 1 }); 
        navigate("/");
      }
    } catch (error) {
      console.log(error);
      if (error?.response?.data?.error) {
        enqueueSnackbar(error?.response?.data?.error, { variant: "error" });
      }
    }
  };

  return (
    <>
      <div className="back_Login">
        <Container maxWidth="xl" className="login_container">
          <Box className="Login_image">
            <img src={heroimg} alt="images" />
          </Box>
          <Box className="form_Login  dashboard_logins">
            <img src={logoimg} alt="" className="logo_login" />
            <div className="exist_login">
              <Typography variant="h3">Login</Typography>
              <p className="login_p p_login_exist">
                Please sign in using your plan reference number. If you're
                facing any difficulties, just ring us up at
              </p>
              <Typography variant="body1">
                <strong>Call</strong> 03301114442
              </Typography>
              <Typography variant="body1">
                <strong>Email </strong> info@wecareboilerrepair.com
              </Typography>
              <p>You can also:</p>
              <ul>
                <li>Request a repair or service </li>
                <li>Update your details</li>
                <li>Download your documents</li>
                <li>FAQs</li>
              </ul>
            </div>
            <Box className="inputs_div">
              <Box className="input_filde_divs">
                <input
                  type="text"
                  placeholder="Plan Reference Number"
                  onChange={(e) => setReferenceNumber(e.target.value)}
                />
                <Box className="Login_icon">
                  <DraftsIcon sx={{ paddingRight: "2px" }} />
                </Box>
              </Box>
              <Box className="input_filde_divs">
                <input
                  type="text"
                  placeholder="Full Name"
                  onChange={(e) => setFullName(e.target.value)}
                />
                <Box
                  onClick={() => setShowpss(!showpss)}
                  className="Login_icon"
                >
                  {showpss === true ? <LockOpenTwoToneIcon /> : <LockIcon />}
                </Box>
              </Box>
            </Box>
            <div className="forgetr_div">
              <Box className="checkBox_div">
                {" "}
                <FormControlLabel
                  control={<Checkbox className="checkBox" />}
                  label="Remember me on this site"
                />
              </Box>
            </div>
            <Box>
              <Button
                variant="contained"
                className="Login_btn mb-3"
                onClick={handelAPIFunc}
              >
                Sign in
              </Button>
            </Box>
          </Box>
        </Container>
      </div>
    </>
  );
};

export default CheckUser;
